import type { ActionFunctionArgs } from '~/types/route-args';
import { data } from 'react-router';
import { markAllWebsiteNotificationsAsRead } from '~/modules/notifications/api/mark-website-notifications-as-read.server';

export const MARK_ALL_WEBSITE_NOTIFICATIONS_AS_READ_API_ROUTE =
    '/remix-api/notifications/mark-all-as-read';

/**
 * Mark all website notifications as read for the current member.
 */
export const action = async ({ context }: ActionFunctionArgs) => {
    const response = await markAllWebsiteNotificationsAsRead({ context });

    if (!response) {
        return data(null, { status: 500 });
    }

    return response;
};
